import React from 'react';

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
} from '@material-ui/core';
import { isFunction } from 'lodash';
import PropTypes from 'prop-types';

import * as S from './styles';

export default function TabelaMovimentacao({
  title,
  cells,
  data,
  height,
  size,
  onIconClick,
}) {
  const [selectedRow, setSelectedRow] = React.useState(null);

  const handleRowClick = (row) => {
    setSelectedRow(row);
  };

  const textStyle = {
    textAlign: 'right', // Right-align the text within the element
    flex: 1, // Optional: makes the text container flexible
  };

  return (
    <>
      {/* {JSON.stringify(data)} */}

      <S.WrapperTabela height={height}>
        <S.WrapperTitle>{title}</S.WrapperTitle>
        <TableContainer>
          <Table stickyHeader aria-label="sticky table" size={size}>
            <TableHead>
              <TableRow>
                {cells.map((cell, index) => (
                  <TableCell
                    key={`cell-index-head-${index}`}
                    align={cell.align || 'left'}
                  >
                    {cell.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(data)
                ? data.map((item, index) => (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={`table-row-body-${index}`}
                      onClick={() => handleRowClick(item)}
                    >
                      {cells.map((cell, indexKey) => (
                        <TableCell
                          key={`table-cell-body-${indexKey}`}
                          align={cell.align || 'left'}
                        >
                          <Box
                            display="flex"
                            // alignItems="center"
                            alignItems={cell.align || 'center'}
                            style={{
                              display: 'flex',
                              justifyContent:
                                cell.id === 'acao'
                                  ? 'flex-end'
                                  : 'space-between',
                              textAlign: cell.align,
                            }}
                          >
                            {cell.format && (
                              <label
                                style={
                                  isFunction(cell.styled)
                                    ? cell.styled(item[cell.id])
                                    : { textAlign: cell.align, flex: 1 }
                                }
                              >
                                {cell.format(item[cell.id])}
                              </label>
                            )}
                            {!cell.format && (
                              <label
                                style={
                                  isFunction(cell.styled)
                                    ? cell.styled(item[cell.id])
                                    : {}
                                }
                              >
                                {item[cell.id]}
                              </label>
                            )}
                            {cell.action &&
                              cell.action.map((acao) => (
                                <div title={acao.label}>
                                  <acao.botao
                                    style={
                                      isFunction(cell.styledIcon)
                                        ? cell.styledIcon(item[cell.id])
                                        : {
                                            marginLeft: item[cell.id] ? 8 : 0,
                                            color: '#999999',
                                            cursor: 'pointer',
                                          }
                                    }
                                    onClick={() =>
                                      onIconClick(item.idmovimentacao)
                                    }
                                  />
                                </div>
                              ))}
                          </Box>
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      </S.WrapperTabela>
    </>
  );
}

TabelaMovimentacao.propTypes = {
  title: PropTypes.string.isRequired,
  cells: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      align: PropTypes.string,
      format: PropTypes.func,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  height: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  showDefaultValue: PropTypes.string,
};

TabelaMovimentacao.defaultProps = {
  height: '100%',
  size: 'medium',
  showDefaultValue: 'S',
};
